<template>
    <template v-if="mode === 'table'">
        <!-- <div v-if="isNaN(modelValue)"> {{formatDate(v)}} </div>  {{ modelValue }} {{ v }}{{ typeof(modelValue) }} {{ typeof(v) }} -->
         <div v-if="modelValue!=='1970-01-01 00:00:00'">{{formatDate(v)}}</div>
    </template>
    <template v-else-if="mode === 'view'">
        <!-- <div v-if="v"> {{formatDate(v)}} </div> -->
        <div v-if="modelValue!=='1970-01-01 00:00:00'">{{formatDate(v)}}</div>
    </template>
    <template v-else-if="mode === 'edit'"> 


        <!-- <VueDatePicker v-model="v" placeholder="Start Typing ..." text-input @date-update ="handleInput" :format=formatdate /> -->
         <VueDatePicker class="my-picker-class" v-model="v" placeholder="DD.MM.YYYY" typeable text-input enterSubmit tabSubmit 
         @update:model-value ="handleInput" :format=formatdate 
    :min-date="new Date(1600, 0, 1)"
    :year-range="[1600, 2100]" 
    prevent-min-max-navigation
         >
            <template #menu-header  >
                <div class="text-center" >{{ column.title }}</div>
            </template>
        </VueDatePicker>    



    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<script>

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
    export default {
        name: 'date-widget',

        components: {
        //    Datepicker,
        // VDateInput,
        VueDatePicker,
   //     ru,
        },

        props:['mode','column', 'modelValue'],
        emits: ['update:modelValue'],
        data(){ 
            let datevalue = '';
                if(this.modelValue!=='1970-01-01 00:00:00'){
                    datevalue = this.modelValue;
                }
                else {
                    datevalue = '';
                }
            return {

                v: datevalue,
//                v: this.modelValue,
formatdate: 'dd.MM.yyyy', // take from store?


            }
        },   
        methods:{
            formatDate(v) {
                if (v==null) {
                    return "";
                }
                else {
                    const date = new Date(v);
                    if (!isNaN(date)) {
                    return new Intl.DateTimeFormat('ru-RU', {dateStyle: 'short'}).format(date);
                    }
                    else {
                    return "dd.MM.yyyy";    
                    }
                }
            },

handleInput (e) {           
    console.log(e);
    let choosedvalue = '';
    
    if (e !== null) {
        choosedvalue = e;
        
        // Создаем объект даты
        const d = new Date(choosedvalue);
        
        // Вручную собираем YYYY-MM-DD, дополняя нулями
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        
        const date = `${year}-${month}-${day}`;
        
        this.$emit('update:modelValue', date);
    } else {
        choosedvalue = null;
        this.$emit('update:modelValue', null);
    }  
    this.v = choosedvalue;
}
        },

        watch: {
            modelValue() {
                this.v = this.modelValue;
            }
        },
    }
</script>

<style scoped>
.my-picker-class{
    --dp-input-padding: 15px 30px 15px 12px; /*Padding in the input*/
    --dp-font-size: 1rem;
    --dp-preview-font-size: 0.8rem; /*Font size of the date preview in the action row*/
           }
</style>